import { render, staticRenderFns } from "./CultureAdd.vue?vue&type=template&id=253fb7f3&scoped=true"
import script from "./CultureAdd.vue?vue&type=script&lang=js"
export * from "./CultureAdd.vue?vue&type=script&lang=js"
import style0 from "./CultureAdd.vue?vue&type=style&index=0&id=253fb7f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253fb7f3",
  null
  
)

export default component.exports